import React, { useCallback, useEffect, useState } from 'react';
import { Page } from './styles'
import { BiEnvelope, BiLock } from "react-icons/bi";
import LogoSvg from '../../assets/Logo.svg';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { Spin } from 'antd';

const Login = () => {
  const navigate = useNavigate();
  const { signIn, loading  } =  useAuth()
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [password, setPassword] = useState("");
  const handleSubmit = useCallback(async (event)=> {
    try {
      event.preventDefault()
      await signIn(
        email.trim(),
        password
      )
      navigate('/dashboard')
     
    } catch (error: any) {
      setErrorMessage(error.message)
    }
  },[navigate,email,password,signIn])
  useEffect(()=>{
    if(errorMessage){
      setTimeout(() => {
        setErrorMessage("") 
      }, 3000);
    }
  },[errorMessage])
  return (
    <Page>
    <form  className="container" onSubmit={handleSubmit}>
      <div  className="description">
        <img src={LogoSvg} alt="Logo" />
        <div className="title" >
          PipeGo - API
        </div>
      </div>
      <span className="text">Login</span>
      <p>Email</p>
      <label  className="form-group">
      <BiEnvelope  style={{width: '25px', height:'25px'}}  />
      <div className='vertical-line'></div>
        <input type='txt' placeholder="Digite seu email..." onChange={(event) => setEmail(event.target.value)} />
      </label >
      <p>Senha</p>
      <label className="form-group">
      <BiLock style={{width: '25px', height:'25px'}}  />
      <div className='vertical-line'></div>
        <input type='password'  placeholder="Digite sua senha..." onChange={(event) => setPassword(event.target.value)} />
      </label>
      {
        errorMessage && <div className="error-message">{errorMessage}</div>
      }
      {
        loading
        ?<div className='btn loading'><Spin /></div>
        :<button type="submit" className='btn'>Entrar</button>
      }
      
     
    </form>
    </Page>
  )
}
export { Login }